import { CreditCardCriteria } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';

export const borrowerNameFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.4,
    field: 'borrower_name',
    sortable: false,
    align: 'left',
    headerName: <Text tId={'CLIENT'} />,
    searchable: true,
    renderCell: (rowData: { row: CreditCardCriteria }) => (
      <>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'break-spaces',
            lineHeight: '1.43',
          }}
        >
          <div className={'line-clamp-3'}>
            {rowData.row.customer.fullName.firstName} {rowData.row.customer.fullName.lastName}
          </div>
        </div>
      </>
    ),
  };
};
